export const resolveFullDate = (dateStr, split = '/', isApiData) => {
  const dateStrSplit = dateStr.split(split)
  const day = dateStrSplit[0]
  const month = dateStrSplit[1]
  const year = dateStrSplit[2]

  if (isApiData) return `${year}-${month}-${day}`
  return `${day} ${dobMonth(parseInt(month))} ${parseInt(year) + 543}`
}

export const resolveShortDate = (dateStr, split = '/', isApiData) => {
  const dateStrSplit = dateStr.split(split)
  const day = dateStrSplit[0]
  const month = dateStrSplit[1]
  const year = dateStrSplit[2]

  if (isApiData) return `${year}-${month}-${day}`
  return `${day} ${dobShortMonth(parseInt(month))} ${parseInt(year) + 543}`
}

export const resolveDateISO = (dateISO, fullMonth = false) => {
  const dateStrSplit = dateISO.split('T')
  const dayStr = dateStrSplit[0].split('-')
  const day = dayStr[2]
  const month = dayStr[1]
  const year = dayStr[0]
  if (fullMonth) {
    return `${day} ${dobMonth(parseInt(month))} ${parseInt(year) + 543}`
  }
  return `${day} ${dobShortMonth(parseInt(month))} ${(parseInt(year) + 543)
    .toString()
    .slice(-2)}`
}

export const resolveDateISOFormat = dateISO => {
  const dateStrSplit = dateISO.split('T')
  const dayStr = dateStrSplit[0].split('-')

  let result = {}

  if (dayStr.length > 0) {
    result = {
      DAY: parseInt(dayStr[2]),
      MONTH: parseInt(dayStr[1]),
      YEAR: parseInt(dayStr[0]),
    }
  }

  return result
}

export const fixedNum = (number, pad) => number.toString().padStart(pad, '0')

export const dobShortMonth = val => {
  if (val == 1) return 'ม.ค.'
  if (val == 2) return 'ก.พ.'
  if (val == 3) return 'มี.ค.'
  if (val == 4) return 'เม.ย.'
  if (val == 5) return 'พ.ค.'
  if (val == 6) return 'มิ.ย.'
  if (val == 7) return 'ก.ค.'
  if (val == 8) return 'ส.ค.'
  if (val == 9) return 'ก.ย.'
  if (val == 10) return 'ต.ค.'
  if (val == 11) return 'พ.ย.'
  if (val == 12) return 'ธ.ค.'
}

export const dobMonth = val => {
  if (val == 1) return 'มกราคม'
  if (val == 2) return 'กุมภาพันธ์'
  if (val == 3) return 'มีนาคม'
  if (val == 4) return 'เมษายน'
  if (val == 5) return 'พฤษภาคม'
  if (val == 6) return 'มิถุนายน'
  if (val == 7) return 'กรกฎาคม'
  if (val == 8) return 'สิงหาคม'
  if (val == 9) return 'กันยายน'
  if (val == 10) return 'ตุลาคม'
  if (val == 11) return 'พฤศจิกายน'
  if (val == 12) return 'ธันวาคม'
}
